const input = require('../input/input');

const date = Object.assign({}, input, {
    subelements: {
        validationMessage: null
    },
    validationTriggeringEvents: ['change'],
    minDate: false,
    maxDate: false,
    startOfTheWeek: 1,
    format: 'yyyy-MM-dd',
    locale: 'en',
    time: false,
    pastEndofTime: '1970-01-01',
    futureEndOfTime: '2200-12-31',
    disabledDaysOfTheWeek: [],
    tempusDominusObj: false,

    init: function () {
        input.init.call(this);

        let daysOfWeekDisabled = [];
        this.disabledDaysOfTheWeek.forEach((dayNo) => {
            if (dayNo > 6) {
                dayNo -= 7;
            }
            daysOfWeekDisabled.push(dayNo);
        });

        let initParams = {
            display: {
                components: {
                    calendar: true,
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    clock: this.time,
                    hours: this.time,
                    minutes: this.time,
                    seconds: false,
                    useTwentyfourHour: undefined
                },
                buttons: {
                    today: true,
                    clear: true,
                    close: true
                },
            },
            localization: {
                startOfTheWeek: this.startOfTheWeek,
                format: this.format,
                locale: this.locale
            },
            restrictions: {
                minDate: this.minDate === false ? undefined : this.minDate,
                maxDate: this.maxDate === false ? undefined : this.maxDate,
                disabledDates: [],
                enabledDates: [],
                daysOfWeekDisabled: daysOfWeekDisabled,
                disabledTimeIntervals: [],
                disabledHours: [],
                enabledHours: []
            }
        };

        //this.hm.log('init params', initParams);

        this.tempusDominusObj = new tempusDominus.TempusDominus(this.element, initParams);
    }
});

module.exports = date;